<template>
  <nav
    class="my-8 mx-auto max-w-[1400px] bg-black px-2 md:px-10 py-8 border-t-2 border-white shadow-black shadow-xl"
    aria-label="Related pages"
  >
    <h2 class="text-white font-russo text-[20px] pb-4 text-center">
      Related Guides
    </h2>
    <ul
      class="flex flex-wrap justify-center gap-x-8 gap-y-3 font-arial text-[16px] font-bold"
    >
      <li v-for="link in links" :key="link.to">
        <router-link :to="link.to" class="text-[#FF0000] hover:underline">
          {{ link.text }} &rarr;
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'RelatedGuides',
  props: {
    links: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped></style>
